const optionsRegex = /\$\(\w+\)/g

// Map an a form array and corresponding parameters to Array of paragraphs filled in
export function mapFormLetterOptions (paragraphs, parameters) {
  const mapped = paragraphs.map((block, index) => {
    if (block.type === 'text') {
      const matches = block.text.match(optionsRegex)
      if (matches) {
        let mappedText = block.text
        matches.forEach(optionMatch => {
          const optionString = optionMatch.slice(2, optionMatch.length - 1)
          // if preserves the error string instead of passing undefined
          // e.g. $(locaton) vs $(location)
          if (parameters[optionString]) {
            mappedText = mappedText.replace(optionMatch, parameters[optionString])
          }
        })
        return Object.assign(block, { text: mappedText })
      } else return block
    } else return block
  })
  return mapped
}

// Map an array of paragraph strings to a TipTap Editor Object
export function mapForEditor (paragraphs) {
  const mappedForEditor = paragraphs.map(text => {
    return {
      type: 'paragraph',
      content: [{
        type: 'text',
        text: text,
      }],
    }
  })
  return {
    type: 'doc',
    content: mappedForEditor,
  }
}

// The output JSON object from TipTap editor contains paragraphs with nested content.
// This function flattens that Object and returns an array with type (text or image) and text or src, accordingly
export function mapForPreview (paragraphs) {
  // TODO: Array.reduce()?
  let content = []
  paragraphs.forEach(paragraph => {
    if (paragraph.content) {
      paragraph.content.forEach(block => {
        if (block.type === 'text') {
          content.push({
            type: 'text',
            text: block.text,
          })
        } else if (block.type === 'image') {
          content.push({
            type: 'image',
            src: block.attrs.src,
          })
        }
      })
    }
  })
  return content
}

// Maps an array of editor paragraphs and returns the array of options
export function mapOptionsFromContent (paragraphs) {
  const content = paragraphs.filter(paragraph => {
    if (paragraph.type === 'text') {
      return paragraph.text
    }
  })

  const options = content.reduce((accumulator, current) => {
    const match = current.text.match(optionsRegex)
    if (match) {
      match.forEach(option => {
        accumulator.push(option)
      })
    }
    return accumulator
  }, [])
  return options
}

export const owalDefault = {
  id: '0w4L-D3f4Vl7-###',
  description: 'OWAL Default',
  content: [
    'Dear Resident,',
    'We recently sent out a memo to all tenants providing background on a new tool that $(management) is employing to provide the safest and best community experience for our residents.',
    'We are contacting you as we have been alerted to objectionable behavior in the common hallways and/or stairwells of the building by either you, your family, or your guests on $(date), in $(location).',
    'Please help us keep the shared spaces in our building comfortable for all of our residents. Greater detail of our policies can be found in your Lease Agreement. Multiple warnings may lead to eviction and sharing of this data with Housing and Preservation Development (HPD).',
    'Sincerely, $(management)',
  ],
  options: [
    'date',
    'location',
    'management',
  ],
}
